var f = typeof global == "object" && global && global.Object === Object && global, l = typeof self == "object" && self && self.Object === Object && self, g = f || l || Function("return this")(), e = g.Symbol, o = Object.prototype, s = o.hasOwnProperty, j = o.toString, r = e ? e.toStringTag : void 0;
function y(t) {
  var a = s.call(t, r), i = t[r];
  try {
    t[r] = void 0;
    var c = !0;
  } catch {
  }
  var b = j.call(t);
  return c && (a ? t[r] = i : delete t[r]), b;
}
var d = Object.prototype, O = d.toString;
function S(t) {
  return O.call(t);
}
var T = "[object Null]", u = "[object Undefined]", n = e ? e.toStringTag : void 0;
function v(t) {
  return t == null ? t === void 0 ? u : T : n && n in Object(t) ? y(t) : S(t);
}
function h(t) {
  return t != null && typeof t == "object";
}
var m = Array.isArray;
export {
  e as S,
  m as a,
  v as b,
  f,
  h as i,
  g as r
};
